export default {
  api_keys: "API Keys",
  api_docs: "Documentation",
  keys_count: "{current} / {total} keys",
  unnamed: "Unnamed",
  edit_name: "Edit Name",
  upgrade_to_enable: "Upgrade to enable API key functionality",
  no_api_keys: "No API Keys",
  generate_key: "Generate Key",
  upgrade_to_generate: "Upgrade to Generate Key",
  api_calls: "API Calls",
  endpoint_stats: "Endpoint Call Statistics",
  refresh: "Refresh",
  free_plan_api_stats:
    "Free plan users cannot view API call statistics. Please upgrade to view detailed data.",
  data_updates: "Data updates every 5 minutes",
  api_call_logs: "API Call Logs",
  api_call_logs_desc:
    "Only requests using valid API keys can be viewed here. Data updates every 5 minutes",
  select_api_key: "Select API Key",
  endpoint: "Endpoint",
  response_time: "Response Time",
  api_quota: "API Quota",
  upgrade: "Upgrade",
  current_plan: "Current Plan",
  key_count: "Key Count",
  call_limit: "Call Limit",
  no_access: "No access",
  daily_limit: "{limit} calls per day",
  total_limit: "Total limit {limit} calls",
  monthly_limit: "{limit} calls per month",
  calc_quota: "Calculation Quota",
  calc_and_report_quota: "Calculation and Report Quota",
  report_quota: "Report Quota",
  daily_report_quota: "Daily Reports",
  extra_quota: "Extra quota: {count} calls",
  edit_key_name: "Edit Key Name",
  key_name: "Key Name",
  key_name_placeholder: "Please enter a key name",
  key_name_desc: "Give your API key an easily recognizable name",
  feature_restricted: "Feature Restricted",
  feature_restricted_desc1: "Your current plan cannot use this feature",
  feature_restricted_desc2:
    "Free plan users cannot use API key related features. Please upgrade to a paid plan to unlock full functionality.",
  upgrade_benefits: "Upgrade plan benefits:",
  benefit1: "Generate and manage API keys",
  benefit2: "View API call statistics and trends",
  benefit3: "Copy and use API keys",
  benefit4: "Higher calculation and report quotas",
  benefit5: "More advanced features",
  response_data_details: "Response Data Details",
  call_count: "{count} calls",
  name_required: "Name cannot be empty",
  name_too_long: "Name length cannot exceed 20 characters",
  key_generated: "Key generated successfully",
  key_deleted: "Deleted successfully",
  key_updated: "Name updated successfully",
  upgrade_required: "Please upgrade",
  loading_docs: "Loading API documentation...",
  docs_load_error: "Documentation loading error",
  docs_load_error_desc: "There was an error loading the API documentation. Please try again.",
  close_window: "Close window",
  delete_confirm: "Confirm deletion?",
  today: "Today",
  this_month: "This month",
  usage: "Usage",
  plan_quota: "Plan quota: {count} calls",
  name: "Name",
  api_key: "API Key",
  created_at: "Created At",
  action: "Action",
  response_status: "Status Code",
  response_data: "Response Data",
  call_count_name: "Call Count",
  update_failed: "Update failed",
  restricted: "Restricted",
};
